import { __extends } from "tslib";
import Manager from '../Abstracts/Manager';
var ModuleManager = /** @class */ (function (_super) {
    __extends(ModuleManager, _super);
    /* CONSTRUCTOR */
    function ModuleManager() {
        var _this = _super.call(this) || this;
        _this.dictionaryNumber = new Map();
        _this.dictionaryString = new Map();
        return _this;
    }
    ModuleManager.prototype.registerModule = function (idModule, nameModule) {
        this.dictionaryNumber.set(idModule, nameModule);
        this.dictionaryString.set(nameModule, idModule);
    };
    ModuleManager.prototype.resolveModuleById = function (idModule) {
        return this.dictionaryNumber.get(idModule);
    };
    ModuleManager.prototype.resolveModuleByString = function (string) {
        return this.dictionaryString.get(string);
    };
    return ModuleManager;
}(Manager));
export default ModuleManager;
